export enum EModalStep {
  FIRST_STEP = 'FIRST_STEP',
  SECOND_STEP = 'SECOND_STEP',
  THIRD_STEP = 'THIRD_STEP',
  FOURTH_STEP = 'FOURTH_STEP',
}
